import StatusUpdateTileContainer from './status_update_tile_container';

const StatusUpdateTile = StatusUpdateTileContainer;
export default StatusUpdateTile;
